module.exports = __webpack_public_path__ + "static/media/star_2.5fd01d98.svg";